(() => {
  let pointsWaitExpired = false;
  // Read presentation data from Appstle's own customer widget, never an API key or a second ledger.
  const updatePoints = () => {
    const roots = document.querySelectorAll('#customer_dashboard .skr-club');
    if (!roots.length) return;
    const launcher = document.querySelector('#appstle-loyalty-button.logged-in-customer-loyalty-button.appstle_show_points');
    const balance = launcher?.querySelector('.loyalty_widget_available_points')?.textContent.trim();
    const ready = Boolean(launcher && balance && /^[\d\s.,]+$/.test(balance));
    roots.forEach(root => {
      root.querySelectorAll('[data-skr-points-balance]').forEach(value => {
        const next = ready ? balance : '—';
        if (value.textContent !== next) value.textContent = next;
        if (ready) value.removeAttribute('aria-label');
      });
      root.querySelectorAll('[data-skr-points-widget]').forEach(button => {
        if (button.disabled === ready) button.disabled = !ready;
      });
      const loading = root.querySelector('[data-skr-points-loading]');
      const hideLoading = ready || pointsWaitExpired;
      if (loading && loading.hidden !== hideLoading) loading.hidden = hideLoading;
      const error = root.querySelector('[data-skr-points-error]');
      if (error) error.hidden = ready || !pointsWaitExpired;
    });
    document.body.classList.toggle('skr-points-integrated', ready);
  };
  let pointsUpdateQueued = false;
  const pointsObserver = new MutationObserver(() => {
    if (pointsUpdateQueued) return;
    pointsUpdateQueued = true;
    requestAnimationFrame(() => { pointsUpdateQueued = false; updatePoints(); });
  });
  pointsObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  updatePoints();
  setTimeout(() => { pointsWaitExpired = true; updatePoints(); }, 20000);
  const changePanel = (root, name, focusTab = false) => {
    const target = root.querySelector(`[data-skr-club-tab="${name}"]`);
    if (!target) return;
    root.querySelectorAll('[data-skr-club-tab]').forEach(tab => {
      const active = tab === target;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = root.querySelector(`#${tab.getAttribute('aria-controls')}`);
      if (panel) panel.hidden = !active;
    });
    if (focusTab) target.focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    const pointsButton = event.target.closest('[data-skr-points-widget]');
    if (pointsButton && pointsButton.closest('#customer_dashboard .skr-club')) {
      const launcher = document.querySelector('#appstle-loyalty-button.logged-in-customer-loyalty-button.appstle_show_points');
      const error = pointsButton.closest('.skr-club').querySelector('[data-skr-points-error]');
      if (error) error.hidden = Boolean(launcher);
      launcher?.click();
      return;
    }
    const button = event.target.closest('[data-skr-club-tab], [data-skr-club-open]');
    const root = button?.closest('.skr-club');
    if (!root) return;
    changePanel(root, button.dataset.skrClubTab || button.dataset.skrClubOpen, Boolean(button.dataset.skrClubOpen));
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-skr-club-tab]');
    const root = tab?.closest('.skr-club');
    if (!root || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = Array.from(root.querySelectorAll('[data-skr-club-tab]'));
    const current = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    changePanel(root, tabs[next].dataset.skrClubTab, true);
  });
})();
